export default {"src":"/_next/static/media/iaas.563bd38b.svg","height":142,"width":142,"blurWidth":0,"blurHeight":0};